"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructEventProps = exports.track = void 0;
const axios_1 = __importDefault(require("axios"));
const uuid_1 = require("uuid");
const track = (params, apiHost) => {
    return new Promise((resolve, reject) => {
        if (!apiHost) {
            reject('Track apiHost is not defined');
            return;
        }
        axios_1.default
            .post(apiHost + '/v1/t', params)
            .then(response => {
            return resolve(response.data);
        })
            .catch(error => {
            reject(error);
        });
    });
};
exports.track = track;
const getPageContext = (params) => {
    const values = params?.context?.page;
    if (params.isWeb) {
        let inIframe;
        try {
            inIframe = window.self !== window.top;
        }
        catch (e) {
            inIframe = true;
        }
        return {
            referrer: values?.referrer || document.referrer,
            path: values?.path || location.pathname,
            title: values?.title || document.title,
            url: values?.url || location.href,
            search: values?.search || location.search,
            language: values?.language ||
                document.getElementsByTagName('html')[0].getAttribute('lang') ||
                'en',
            inIframe,
        };
    }
    return values;
};
const constructEventProps = (params, writeKey) => {
    const uuid = (0, uuid_1.v4)();
    const sentAt = new Date();
    const { event, properties, traits, anonymousId, type, userId } = params;
    return {
        sentAt: sentAt,
        timestamp: sentAt,
        context: {
            library: {
                name: params?.context?.library?.name || 'stats-analytics',
                version: params?.context?.library?.version || '0.0.1',
            },
            page: getPageContext(params),
            userAgent: params?.context?.userAgent,
            sessionId: params?.context?.sessionId,
        },
        messageId: 'ajs-' + uuid.replace(/-/g, ''),
        event,
        properties,
        traits,
        type: type || 'track',
        writeKey: writeKey,
        anonymousId,
        userId: userId || undefined,
    };
};
exports.constructEventProps = constructEventProps;
//# sourceMappingURL=stats-api-v2.js.map